"use client";
import { Vehicle, VehicleStatusType } from "@alba-cars/common-modules";
import Image from "next/image";
import { useParams, useRouter, useSearchParams } from "next/navigation";
import React from "react";

import PercentageSlider from "@/components/common/PercentageSlider";
import SectionTitle from "@/components/ui/SectionTitle";
import { cn, getCarMonthlyInstallment, getCarPrice } from "@/lib/utils";
import LoanSummaryCard from "./LoanSummaryCard";
import LoanTenureSelector from "./LoanTenureSelector";

const CarDetailsEMI = ({ car, className }: { car: Vehicle; className?: string }) => {
  const [EMI, setEMI] = React.useState<{
    actualValue: string;
    percentage: number;
  }>({ actualValue: "0", percentage: 0 });

  const { slug } = useParams();
  const searchParams = useSearchParams();
  


  const router = useRouter();

  const [loanTenure, setLoanTenure] = React.useState<number>(5);

  const carPrice = getCarPrice(car);
  const installment = getCarMonthlyInstallment(car);
  return (
    <div className={cn("rounded-3xl bg-white p-8", className)}>
      <div className="flex flex-col lg:flex-row lg:space-x-5">
        <div className="xl:mb-3 lg:w-1/2">
          <SectionTitle
            title="Estimate your monthly installment"
            showButton={false}
            showIcon={false}
            className="!mb-2 lg:!mb-4 xl:!mb-8"
          />
        </div>
        <div className="mb-3 rounded-2xl border border-primary-light bg-primary-light lg:w-1/2">
          <div className="items-center flex pb-2 pl-3 pt-2 lg:pl-8">
            <Image alt="" src={"/assets/images/percentage.png"} width={65} height={65}></Image>
            <div className="ml-4">
              <p className="font-inter text-base font-bold text-primary">Downpayment for all cars</p>
              <p className="font-inter text-base font-bold text-black">1 Year free warranty</p>
            </div>
          </div>{" "}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-y-3 lg:grid-cols-2 lg:gap-x-4">
        <div className="rounded-3xl border border-secondary-light p-4 font-inter text-sm font-medium text-secondary-foreground">
          <h4>Select downpayment</h4>
          <PercentageSlider totalValue={carPrice} initialPercentage={0} onChange={setEMI} />
          <LoanTenureSelector carYear={car.year} onChange={setLoanTenure} selectedYear={loanTenure} />
        </div>
        <LoanSummaryCard
          tenure={loanTenure}
          totalPrice={carPrice}
          downPaymentPercentage={EMI.percentage ?? 0}
          interestRate={car?.finance?.interestPercentage ?? 3.5}
          car={car}
          onStartFinancing={() => {
            router.push(`/used-car-finance`);
          }}
        />
      </div>
    </div>
  );
};

export default CarDetailsEMI;
